<template>
  <div class="Box" id="login-denglu">
    <div class="stelllog">
      <div class="stelllog-1">
        <div class="log1">
          <img :src="linkerImg" alt="同豪LOGO" class="imglog" />
        </div>
        <h4>欢迎使用同豪加密锁管理系统</h4>
        <div>
          <ul>
            <li>
              <i class="fa fa-arrow-circle-o-right m-r-xs"></i> 加密锁许可更新
            </li>
            <li>
              <i class="fa fa-arrow-circle-o-right m-r-xs"></i> 加密锁常见问题
            </li>
            <li>
              <i class="fa fa-arrow-circle-o-right m-r-xs"></i> 加密锁技术支持
            </li>
            <li>
              <i class="fa fa-arrow-circle-o-right m-r-xs"></i> 加密锁授权
            </li>
            <li>
              <i class="fa fa-arrow-circle-o-right m-r-xs"></i> 加密锁效率提高
            </li>
          </ul>
        </div>
      </div>
      <div class="login">
        <div class="form">
          <h4>登录</h4>
          <div class="land">
            <label for>用户名:</label>
            <br />
            <font color="red">
              <span v-if="yanzheng">{{ yanzhengtishi }}</span>
            </font>
            <br />
            <input type="text" id="user" v-model="username" />
            <br />
            <label for>密码:</label>
            <br />
            <br />
            <input type="password" id="password" v-model="password" />
          </div>
          <div>
            <div class="Verification">
              <input
                id="Verification"
                type="text"
                placeholder="验证码"
                v-model="verifycode"
                @keyup.enter="loginsubmit"
              />
              <br />
            </div>
            <div class="Verification-tupian">
              <a href="javascript:void(0);" title="点击更换验证码">
                <img id="image" :src="codeurl" @click="tupian()" />
              </a>
            </div>
          </div>
          <br />
          <div class="wjmm" id="wjmm">
            <app-wjmmdialog></app-wjmmdialog>
          </div>
          <div class="check" id="registerclick">
            <app-dialog></app-dialog>
          </div>
          <div class="loginbutton">
            <!-- <router-link :to="{name:'home'}"> </router-link>  -->
            <button id="login" @click="loginsubmit">登录</button>
          </div>
        </div>
      </div>
    </div>
    <div class="Pagetail">
      <div>© 2019 上海同豪土木工程咨询有限公司</div>
    </div>
  </div>
</template>   
<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      verifycode: "",
      yanzheng: false,
      yanzhengtishi: "",
      linkerImg: require("../../assets/logo.png"),
      codeurl: this.$getaxiosurl("/getVerifyCode"),
    };
  },
  methods: {
    loginsubmit() {
      var _this = this;
      var formData = new FormData();
      formData.append("username", this.username);
      formData.append("password", this.password);
      formData.append("verifyCode", this.verifycode);
      this.$axios.defaults.withCredentials = true;
      this.$axios
        .post(this.$getaxiosurl("/login"), formData)
        .then(function (response) {
          if (response.data.code != "00100") {
            _this.yanzheng = true;
            _this.yanzhengtishi = response.data.msg;
          }
          if (response.data.code === "00100") {
            sessionStorage.setItem("username", _this.username);
            sessionStorage.setItem("userToken", response.data.data);
            _this.$router.replace("/home/HomePage");
          } else {
            if (response.data.code == "999999") {
              return this.$message({
                showClose: true,
                message: "系统错误，请求失败",
                type: "error",
              });
            }
          }
        });
    },
    tupian() {
      let image = document.getElementById("image");
      image.src =
        this.$getaxiosurl("/getVerifyCode?") + "type=" + Math.random();
    },
  },
};
</script>
<style scoped>
.Box {
  margin: 0;
  padding: 0;
  width: 100%;
  position: fixed;
  height: 100%;
  background: url(../../assets/timg5.jpg);
  color: rgba(255, 255, 255, 0.95);
}
.log {
  width: 14.76%;
  height: 8%;
}
.log1 {
  width: 70%;
  height: 8%;
}
.imglog {
  width: 100%;
  height: 100%;
}
.stelllog {
  width: 50%;
  margin: 10% auto 0;
}
.stelllog-1 {
  width: 40%;
  float: left;
}
.stelllog-1::before , .stelllog::after , /*清楚浮动*/
.dengluchuangkou::before , .dengluchuangkou::after,
.Verification-2::before,.Verification-2::after,
.Verification-1::before,.Verification-1::after,
.Verification::before,.Verification::after,
.Verification-tupian::before,.Verification-tupian::after {
  content: " ";
  display: table;
  clear: both;
}
h4 {
  margin-left: 30px;
}
li {
  margin-left: 30px;
  padding-top: 10px;
  font-size: 13px;
}
.form {
  width: 100%;
  padding: 0px;
  margin: 0px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.login {
  width: 40%;
  float: left;
}
.land {
  text-align: center;
}
.land > input {
  width: 80%;
  height: 25px;
  font-size: 14px;
  padding: 0px;
  border: 1px solid;
  border-color: #c9c9c9 #dfdfdf #dfdfdf #c9c9c9;
}
.Verification {
  width: 50%;
  float: left;
}
.Verification > input {
  width: 50%;
  height: 25px;
  margin-top: 15%;
  margin-left: 20%;
  font-size: 14px;
  padding: 0px;
  border: 1px solid;
  border-color: #c9c9c9 #dfdfdf #dfdfdf #c9c9c9;
}
.Verification-tupian {
  width: 50%;
  height: 80px;
  float: left;
}
.Verification-tupian > a {
  width: 100%;
}
#image {
  width: 50%;
  height: 33px;
  margin: 15% 0 0 25%;
}
.check,
.wjmm {
  width: 50%;
  margin-top: 8%;
  font-size: 14px;
  text-align: center;
  float: left;
}
.loginbutton {
  width: 100%;
}
.loginbutton > button {
  width: 70%;
  height: 38px;
  margin: 21px 0 0 15%;
  border: none;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 2px;
  background-color: #1c84c6;
}
.Pagetail {
  width: 50%;
  border-top: solid 1px rgba(255, 255, 255, 0.3);
  margin: 20px auto 0;
  padding-top: 15px;
  font-size: 5px;
}
span {
  font-size: 4px;
}
#asdf {
  margin-left: 20%;
}
</style>